import styled from 'styled-components';

import FormTitle from 'components/PageLayout/FormTitle';
import { ButtonWithLoadingState } from 'components/curo-components/common/Button';
import { Button } from 'components/curo-components/common/Button';
import Table from 'components/curo-components/common/Table';
import { ITableProps } from 'components/curo-components/common/Table/Table';
import Title from 'components/curo-components/common/Title';
import Typography from 'components/curo-components/common/Typography';
import media from 'styles/media.module.scss';

import { ILoanOfferAction } from './SelectLoanOffer.types';
import styles from './SelectLoanOfferStep.module.scss';

const defaultDisclaimer = (
  <>
    <div className={styles.smallText}>*</div>

    <Typography className={styles.smallText}>
      Final approval is conditional based on verification of identity, address, monthly income and
      expenses - additionally, for vehicle secured loans, collateral value. To proceed with this
      offer and continue the loan process click "Accept My Offer" below.
    </Typography>
  </>
);

const defaultSubTitle = 'You’ve been matched to the following loan offer.';

const StyledActions = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 36px;

  @media (max-width: ${media.maxTablet}) {
    flex-direction: column;
  }
`;

interface ISelectLoanOfferStepViewProps {
  title: string;
  subTitle?: string;
  productName: string;
  tableProps: Pick<ITableProps, 'data' | 'rows' | 'columns'>;
  offerExpirationDate: string;
  disclaimer?: React.ReactNode;
  actions: ILoanOfferAction[];
}

const SelectLoanOfferStepView = ({
  title,
  subTitle = defaultSubTitle,
  productName,
  tableProps,
  offerExpirationDate,
  disclaimer = defaultDisclaimer,
  actions,
}: ISelectLoanOfferStepViewProps) => {
  return (
    <>
      <FormTitle title={title} subTitle={subTitle} />

      <div className={styles.offerWrapper}>
        <Title type="h5" className={styles.tableTitle}>
          {productName}
        </Title>
        <Table {...tableProps} />
        <div className={styles.tableFooter}>
          This offer expires on <span>{offerExpirationDate}</span>
        </div>
      </div>

      <div className={styles.textWrapper}>{disclaimer}</div>

      <StyledActions>
        {actions.map((action) =>
          action.kind === 'primary' ? (
            <ButtonWithLoadingState
              key={action.label}
              kind="primary"
              size="form"
              onClick={action.onClick}
            >
              {action.label}
            </ButtonWithLoadingState>
          ) : (
            <Button key={action.label} kind="secondary" size="form" onClick={action.onClick}>
              {action.label}
            </Button>
          ),
        )}
      </StyledActions>
    </>
  );
};

export default SelectLoanOfferStepView;
